<template>
  <div>
    <transition name="modal">
      <div class="modal-mask">
        <div class="w3-container modal-wrapper" @click="$emit('close')">
          <div class="modal-container w3-modal-content " @click.stop>
            <span @click="$emit('close')" class="w3-button w3-display-topright" style="margin-top:0">&times;</span>
            <div class="modal-header">
              <VueSignaturePad 
                style="border: 1px solid black; margin: 10px" 
                :width="largura" 
                :height="altura" 
                saveType="image/jpeg" 
                ref="signaturePad" 
                :options="options" 
                class="modal-assinatura"
              />
              <div class="modal-footer">
                <slot name="footer">
                  <button @click="salvar" class="w3-button">Salvar</button>
                  <button @click="limpar" class="w3-button">Limpar</button>
                </slot>
              </div>
              <div class="alert-assinatura modal-assinatura" v-if="aviso_vazio">
                <p>
                  Assinatura vazia!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import toastr from 'toastr'

  export default {
    name: 'ModalAssinatura2',
    props: [],
    data() {
      return {
        aviso_vazio: false,
        mostrarModalAssinatura: false,
        api: process.env.API,
        assinatura: '',
        options: {
          throttle: 16,
          minDistance: 5,
          backgroundColor: 'white',
          penColor: 'black',
          velocityFilterWeight: 0.7
        }
      }
    },
    computed: {
      altura() {
        if (window.innerWidth < 425) {
          return '380px'
        } else {
          return '150px'
        }
      },
      largura() {
        if (window.innerWidth < 425) {
          return '150px'
        } else {
          return '400px'
        }
      }
    },
    methods: {
      salvar: function(){
        const {isEmpty, data} = this.$refs.signaturePad.saveSignature();

        if (isEmpty) {
          this.aviso_vazio = true;
        } else {
          this.$emit('carregarImagem', data);
          this.$emit('close');
          return;
        }
      },
      TratarWebErroJSONLocal: function(retorno){
        if (retorno.msg != undefined){
          var erro = retorno;
          toastr.error('Código do erro: ' + erro.codigo_erro + ' \n Classe: ' + erro.classe_erro + ' \n Erro: ' + erro.mensagem_erro, 'Erro ao realizar a requisição!');
          return;
        }

        else {
          var erro = retorno;
          toastr.error('Código do erro: ' + erro.codigo_erro + ' \n Classe: ' + erro.classe_erro + ' \n Erro: ' + erro.mensagem_erro, 'Erro ao realizar a requisição!');
          return;
        }
      },
      limpar() {
        this.$refs.signaturePad.undoSignature();
      }
    }
  }
</script>

<style scoped>
  @media (max-width: 450px) {
      .aviso-tamanho-tela {
        display: inherit;
        text-align: center;
        color: red;
      }
  }

  @media screen and (max-width: 768px) {
    .wrapper-modal-assinatura {
      position: absolute !important;
      width: 100% !important;
      height: 100% !important;
    }

    .content-modal-assinatura {
      float: left !important;
      position: absolute !important;
      width: 100% !important;
      height: 100% !important;
    }

    .modal-assinatura {
      min-height: calc(100% - 100px) !important;
      min-width: calc(100% - 30px) !important;
    }
  }

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    animation: animatezoom 0.6s;
    margin: auto;
    height: auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 1  2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  button {
      background: #9c1d1c;
      color: white;
      padding: 5px
  }

  .modal-assinatura {
    margin: auto !important;
  }

  .aviso-tamanho-tela {
    display: none;
  }

  .alert-assinatura{
    color: red;
    text-align: center;
    font-size: 0.9em;
    font-weight: 400
  }

  .w3-button {
    padding: 10px;
    margin-top: 10px
  }
  
  .w3-table td {
    padding: 4px 8px
  }

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #ddd;
  }

  ::-webkit-scrollbar-thumb {
    background: #8d1007;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #9c1d1c;
  }
</style>


// WEBPACK FOOTER //
// src/components/ModalAssinatura2.vue